import React from 'react';
import { Typography } from 'tfc-components';

import Button from 'components/atoms/Button';
import Icon, { IconName } from 'components/atoms/Icon';
import Image from 'components/atoms/Image';
import LoadingSpinner from 'components/atoms/LoadingSpinner';
import mapModifiers from 'utils/functions';

export interface MessageFileProps {
  id: string;
  isForDisplay?: boolean;
  color?: string;
  status?: 'loading' | 'error' | 'success';
  type?: 'file' | 'image';
  fileName?: string;
  fileType?: string;
  fileIcon?: IconName;
  fileSize?: string;
  imgSrc?: string;
  imgAlt?: string;
  onRemove?: (e: any, id: string) => void;
}

const MessageFile: React.FC<MessageFileProps> = ({
  id,
  isForDisplay,
  color,
  status,
  fileName,
  fileType,
  fileIcon,
  fileSize,
  type,
  imgSrc,
  imgAlt,
  onRemove,
}) => (
  <div className={mapModifiers('m-messageFile', isForDisplay && 'display')}>
    <div className="m-messageFile_left">
      {(() => {
        switch (status) {
          case 'loading':
            return (
              <div className="m-messageFile_left_file">
                <LoadingSpinner color={color} />
              </div>
            );
          case 'success':
          case 'error':
            if (type === 'file') {
              return (
                <div className="m-messageFile_left_file">
                  <Icon iconName={fileIcon || 'fileOutline'} size="20x20" />
                </div>
              );
            }
            if (type === 'image') {
              return (
                <div className="m-messageFile_left_image">
                  <Image src={imgSrc || ''} alt={imgAlt} ratio="1x1" />
                </div>
              );
            }
            return null;
          default:
            return (
              <div className="m-messageFile_left_file">
                <Icon iconName={fileIcon || 'fileOutline'} size="20x20" />
              </div>
            );
        }
      })()}
    </div>
    <div className="m-messageFile_middle">
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <Typography.Text extendClasses="m-messageFile_middle_fileName" fontweight="500">
          {fileName || ''}
        </Typography.Text>
        {status === 'error'
          && <Icon iconName="warn" size="20x20" />}
      </div>
      <Typography.Text extendClasses="m-messageFile_middle_fileExtension" fontweight="500">
        {`${fileType} · ${fileSize}`}
      </Typography.Text>
    </div>
    {/* {!isForDisplay && onRemove && ( */}
    <Button
      onClick={(e) => onRemove && onRemove(e, id)}
      variant="icon"
      icon={{
        align: 'right',
        size: '20x20',
        name: 'grayClose',
      }}
      size="p12"
    />
    {/* )} */}
  </div>
);
export default MessageFile;
